module.exports = __webpack_public_path__ + "static/media/building_5.f4f8800d.jpg";